export const systemRoute = {
    path: "/system",
    name: "系统数据",
    meta: { title: "系统数据", affix: true },
    component: resolve => require(["@/components/index"], resolve),
    children: [
        {
            path: "doc",
            name: "文档管理",
            component: resolve => require(["@/components/system/doc"], resolve),
            meta: { title: "文档管理" }
        },
        {
            path: "intf",
            name: "接口统计数据",
            component: resolve => require(["@/components/system/intfStatis"], resolve),
            meta: { title: "接口统计数据" }
        },
        {
            path: "apk",
            name: "安装包管理",
            component: resolve => require(["@/components/system/apk"], resolve),
            meta: { title: "安装包管理" }
        },
        {
            path: "user",
            name: "用户管理",
            component: resolve => require(["@/components/system/user"], resolve),
            meta: { title: "用户管理" }
        },
        {
            path: "role",
            name: "角色管理",
            component: resolve => require(["@/components/system/role"], resolve),
            meta: { title: "角色管理" }
        },
        {
            path: "job",
            name: "定时任务管理",
            component: resolve =>
                require(["@/components/system/job"], resolve),
            meta: { title: "定时任务管理" }
        },
        {
            path: "interface_check",
            name: "接口校验",
            component: resolve =>
                require(["@/components/system/interfaceCheck"], resolve),
            meta: { title: "接口校验" }
        },
        {
            path: "update_log",
            name: "更新日志数据",
            component: resolve =>
                require(["@/components/system/updateLog/index"], resolve),
            meta: { title: "更新日志数据" }
        },
        {
            path: "exchange",
            name: "兑换奖励",
            component: resolve =>
                require(["@/components/system/exchange"], resolve),
            meta: { title: "兑换奖励" }
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/system.js